import { Autocomplete, Box, Button, IconButton, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import personLogo from "../../assets/Images/personLogo.png"
import UserActivityLogo from "../../assets/Images/userActivityLogo.png"
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from '@mui/icons-material/Person';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiGetUsers } from '../../apiService/Core/Apicall';
import PopupDialog from '../../Components/Popups/ConfirmDialog';
import DateRangeFilter from '../../Components/Common/DateRangeFilter'
import { useDateRange } from '../../hooks/useDateRange'
import dayjs from "dayjs";
import { usePersistedState } from '../../hooks/userPersistedState';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { ApiAdjustSpins } from '../../apiService/Core/Apicall';


const Referrals = () => (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 9.54797C23.92 9.53464 23.8267 9.53464 23.7467 9.54797C21.9067 9.48131 20.44 7.97464 20.44 6.10797C20.44 4.2013 21.9733 2.66797 23.88 2.66797C25.7867 2.66797 27.32 4.21464 27.32 6.10797C27.3067 7.97464 25.84 9.48131 24 9.54797Z" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22.6266 19.2549C24.4533 19.5615 26.4666 19.2415 27.88 18.2948C29.76 17.0415 29.76 14.9882 27.88 13.7349C26.4533 12.7882 24.4133 12.4682 22.5866 12.7882" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.95999 9.54797C8.03999 9.53464 8.13332 9.53464 8.21332 9.54797C10.0533 9.48131 11.52 7.97464 11.52 6.10797C11.52 4.2013 9.98665 2.66797 8.07999 2.66797C6.17332 2.66797 4.63998 4.21464 4.63998 6.10797C4.65332 7.97464 6.11999 9.48131 7.95999 9.54797Z" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.33331 19.2549C7.50665 19.5615 5.49332 19.2415 4.07998 18.2948C2.19998 17.0415 2.19998 14.9882 4.07998 13.7349C5.50665 12.7882 7.54665 12.4682 9.37331 12.7882" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16 19.5089C15.92 19.4956 15.8267 19.4956 15.7467 19.5089C13.9067 19.4422 12.44 17.9356 12.44 16.0689C12.44 14.1622 13.9734 12.6289 15.88 12.6289C17.7867 12.6289 19.32 14.1756 19.32 16.0689C19.3067 17.9356 17.84 19.4556 16 19.5089Z" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.12 23.7104C10.24 24.9637 10.24 27.0171 12.12 28.2704C14.2534 29.6971 17.7467 29.6971 19.88 28.2704C21.76 27.0171 21.76 24.9637 19.88 23.7104C17.76 22.2971 14.2534 22.2971 12.12 23.7104Z" stroke="#F2674A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

interface User {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    isBlocked: boolean;
    isDeleted: boolean;
    createdAt: string;
    country: string;
    state: string;
    aeropay_userId: string;
    lastLoggedin: string;
}

const FILTER_OPTIONS = [
    "Total",
    "Active",
    "Inactive",
    "Trading",
    "Pending Trading",
    "Rejected",
    "Booster Loan",
    "Active Monthly",
    "Active Weekly",
    "Funded"
];

const FILTER_TYPE_MAP: Record<string, string> = {
    "Total": "total",
    "Active": "active",
    "Inactive": "inactive",
    "Trading": "trading",
    "Pending Trading": "pendingTrading",
    "Rejected": "rejected",
    "Booster Loan": "boosterLoan",
    "Active Monthly": "activeMonthly",
    "Active Weekly": "activeWeekly",
    "Funded": "funded"
};

type SortKey = 'createdAt' | 'lastLoggedin'
type SortDir = 'asc' | 'desc'

const Users: React.FC = () => {

    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [users, setUsers] = useState<User[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = usePersistedState('users:page', 0);
    const [rowsPerPage, setRowsPerPage] = usePersistedState('users:rowsPerPage', 10);
    const navigate = useNavigate();
    const [spinReasonOpen, setSpinReasonOpen] = useState(false)
    const [spinCount, setSpinCount] = useState('')
    const [spinCountError, setSpinCountError] = useState('')
    const [spinReason, setSpinReason] = useState('')
    const [spinReasonError, setSpinReasonError] = useState('')
    const [pendingSpinUser, setPendingSpinUser] = useState<User | null>(null)
    const [pendingSpinDirection, setPendingSpinDirection] = useState<"CREDIT" | "DEBIT" | null>(null)
    const [confirmSpinOpen, setConfirmSpinOpen] = useState(false)
    const [spinSubmitting, setSpinSubmitting] = useState(false)
    const [successPopup, setSuccessPopup] = useState<{ open: boolean; message: string }>({ open: false, message: '' })
    const [errorPopup, setErrorPopup] = useState<{ open: boolean; message: string }>({
        open: false,
        message: '',
    })
    const [sortKey, setSortKey] = usePersistedState<SortKey>('users:sortKey', 'createdAt')
    const [sortDir, setSortDir] = usePersistedState<SortDir>('users:sortDir', 'desc')
    const fmtDate = (d: string) =>
        new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })
    const fmtTime = (d: string) =>
        new Date(d).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
    const location = useLocation();
    const incomingFilters = location.state as {
        organization?: any;
        range?: any;
        customStart?: any;
        customEnd?: any;
        backButton?: any;
    } | undefined;
    const [organization, setOrganization] = usePersistedState('users:organization', incomingFilters?.organization || "Total");
    const {
        range, setRange, customStart, setCustomStart, customEnd, setCustomEnd, handleRangeChange, buildQuery,
    } = useDateRange('users', incomingFilters?.range || 'all')

    const prevSearchRef = React.useRef(search);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
            if (search !== prevSearchRef.current) {
                setPage(0);
            }
            prevSearchRef.current = search;
        }, 400);
        return () => clearTimeout(timer);
    }, [search, setPage]);

    const prevFiltersRef = React.useRef({ organization, range, customStart, customEnd });
    useEffect(() => {
        const prev = prevFiltersRef.current;
        const changed =
            prev.organization !== organization ||
            prev.range !== range ||
            (prev.customStart?.valueOf() !== customStart?.valueOf()) ||
            (prev.customEnd?.valueOf() !== customEnd?.valueOf());

        if (changed) {
            setPage(0);
        }
        prevFiltersRef.current = { organization, range, customStart, customEnd };
    }, [organization, range, customStart, customEnd, setPage]);

    const [showBackToDashboard] = useState(!!incomingFilters?.backButton);

    const hasAppliedIncomingFilters = React.useRef(false);

    useEffect(() => {
        if (hasAppliedIncomingFilters.current) return;
        hasAppliedIncomingFilters.current = true;

        if (incomingFilters) {

            if (incomingFilters.organization) {
                setOrganization(incomingFilters.organization);
            }

            if (incomingFilters.range) {
                setRange(incomingFilters.range);
            }

            if (incomingFilters.range === 'custom') {
                if (incomingFilters.customStart) {
                    setCustomStart(dayjs(incomingFilters.customStart));
                }
                if (incomingFilters.customEnd) {
                    setCustomEnd(dayjs(incomingFilters.customEnd));
                }
            }

            navigate(location.pathname, {
                replace: true,
                state: {}
            });
        }
    }, [
        incomingFilters,
        location.pathname,
        navigate,
        setOrganization,
        setRange,
        setCustomEnd,
        setCustomStart
    ]);

    useEffect(() => {
        let cancelled = false;
        const fetchUsers = async () => {
            const dateQuery = buildQuery();
            if (dateQuery === null) return;

            try {
                const filterType = FILTER_TYPE_MAP[organization] || "total";
                const params = `?page=${page}&limit=${rowsPerPage}&filterType=${filterType}&search=${debouncedSearch}&sortBy=${sortKey}&sortOrder=${sortDir}${dateQuery ? `&${dateQuery}` : ''}`;
                const response = await ApiGetUsers(params);

                if (cancelled) return;

                if (response.status) {
                    setUsers(response.data);
                    setTotalRows(response.totalRows);
                }
            } catch (error: any) {
                if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') return; // ignore aborted
                console.error('Error fetching users:', error);
                setErrorPopup({
                    open: true,
                    message: error?.message || error?.response?.data?.message || error || 'Something went wrong. Please try again.',
                });
            }
        };
        fetchUsers()
        return () => { cancelled = true; };
    }, [debouncedSearch, page, rowsPerPage, organization, range, customStart, customEnd, sortKey, sortDir, buildQuery]);

    // const handleDownloadUsersExcel = async () => {
    //     try {
    //         const type =
    //             organization === "Active"
    //                 ? "activeUsers"
    //                 : organization === "Inactive"
    //                     ? "inactiveUsers"
    //                     : "";

    //         const dateQuery = buildQuery();
    //         if (dateQuery === null) return;

    //         const res = await ApiGetUsersExcel(`?type=${type}${dateQuery ? `&${dateQuery}` : ''}`);

    //         const blob = new Blob([res], {
    //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //         });

    //         const url = URL.createObjectURL(blob);

    //         const link = document.createElement("a");
    //         link.href = url;
    //         link.setAttribute("download", `${type}.xlsx`);
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //     } catch (error: any) {
    //         console.error("Error Downloading Excel.", error);
    //         setErrorPopup({
    //             open: true,
    //             message: error?.message || error?.response?.data?.message || error || 'Something went wrong. Please try again.',
    //         })
    //     }
    // };

    const HEAD_COLS: { label: string; sortKey?: SortKey }[] = [
        { label: "No" },
        { label: "Name" },
        { label: "Email" },
        { label: "Phone Number" },
        { label: "Country" },
        { label: "State" },
        { label: "Spins" },
        { label: "Created At", sortKey: "createdAt" },
        { label: "Last Login", sortKey: "lastLoggedin" },
        { label: "Actions" },
    ];

    const handleSort = (key: SortKey) => {
        if (sortKey === key) {
            setSortDir(d => (d === 'asc' ? 'desc' : 'asc'))
        } else {
            setSortKey(key)
            setSortDir('desc')
        }
        setPage(0)
    }

    const handleAdjustSpins = async () => {
        if (!pendingSpinUser || !pendingSpinDirection) return
        setSpinSubmitting(true)
        try {
            const res = await ApiAdjustSpins({
                userId: pendingSpinUser._id,
                direction: pendingSpinDirection,
                spinCount: Number(spinCount),
                reason: spinReason.trim(),
            })
            if (res?.status) {
                setSuccessPopup({
                    open: true,
                    message: res?.message || `Spins ${pendingSpinDirection === 'CREDIT' ? 'credited' : 'debited'} successfully`,
                })
                setConfirmSpinOpen(false)
                setSpinCount('')
                setSpinReason('')
                setPendingSpinUser(null)
                setPendingSpinDirection(null)
            }
        } catch (error: any) {
            setErrorPopup({
                open: true,
                message: error?.message || error?.response?.data?.message || error || 'Failed to adjust spins',
            })
        } finally {
            setSpinSubmitting(false)
        }
    }

    return (
        <div className='common-layout flex-column'>
            <Box className="border-10 p-2 px-4 mixed-orange mb-4 both-circle d-flex align-items-center justify-content-between">
                <Box className="d-flex align-items-center gap-3">
                    {showBackToDashboard && (
                        <IconButton
                            sx={{ ':hover': { backgroundColor: '#ffffff1A' } }}
                            onClick={() => navigate(-1)}
                        >
                            <ArrowBackIcon sx={{ color: '#ffffff' }} />
                        </IconButton>
                    )}
                    <Typography className='fs-24 text-white fw-medium'>Users</Typography>
                </Box>
                <Box className="d-flex gap-3 align-items-center">
                    <Button
                        variant="contained"
                        onClick={() => navigate('/admin/incomplete-onboarding-users')}
                        sx={{
                            borderRadius: '10px', fontWeight: 700, px: 3, py: 1,
                            background: 'linear-gradient(135deg, #a78bfa, #7c3aed)',
                            '&:hover': { background: 'linear-gradient(135deg, #9061f9, #6d28d9)' },
                        }}
                    >
                        Incomplete Users
                    </Button>
                    <Box className="p-2 bg-light-white border-10">
                        <img src={personLogo} alt='#' height={"28px"} />
                    </Box>
                    <Typography className='fs-24 text-white fw-medium'>Total Users: {totalRows}</Typography>
                </Box>
            </Box>
            <DateRangeFilter
                range={range}
                onRangeChange={handleRangeChange}
                customStart={customStart}
                onCustomStartChange={setCustomStart}
                customEnd={customEnd}
                onCustomEndChange={setCustomEnd}
            />
            <Box className="bg-dark-color border-10 p-4 mt-2">
                <Box className="d-flex align-items-center gap-3 mb-5 flex-wrap">
                    <TextField
                        placeholder="Search"
                        value={search}
                        onChange={(e) => { setSearch(e.target.value); }}
                        size="small"
                        sx={{
                            width: 350,
                            background: "transparent",
                            borderRadius: "7px",
                            border: "1px solid #898989",
                            transition: "border-color 0.3s",
                            "&:hover": {
                                border: "1px solid #ff6a3d",
                            },
                            "&:focus-within": {
                                border: "1px solid #ff6a3d",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "& input": {
                                color: "#fff"
                            },
                            "& input::placeholder": {
                                color: "#999",
                                opacity: 1,
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon className='color-primary' />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Autocomplete
                        size="small"
                        value={organization}
                        disableClearable={!organization}
                        onChange={(event, newValue) => { setOrganization(newValue || ""); }}
                        options={FILTER_OPTIONS}
                        renderInput={(params) => (
                            <TextField className='text-white'
                                {...params}
                                placeholder="Filter Status"
                                sx={{
                                    width: 220,
                                    "& .MuiInputBase-root": {
                                        background: "transparent",
                                        borderRadius: "8px",
                                        border: "1px solid #898989",
                                        transition: "border-color 0.3s",
                                    },
                                    "& .MuiInputBase-root:hover": {
                                        border: "1px solid #ff6a3d",
                                    },
                                    "& .MuiInputBase-root.Mui-focused": {
                                        border: "1px solid #ff6a3d",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "& input::placeholder": {
                                        color: "#999",
                                        opacity: 1,
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        color: "#fff",
                                        "& .MuiAutocomplete-endAdornment": {
                                            "& .MuiSvgIcon-root": {
                                                color: "#fff",
                                            },
                                        },
                                    },
                                }}
                            />
                        )}
                        sx={{
                            width: 220,
                        }}
                        PaperComponent={({ children }) => (
                            <Box className="bg-dark-color" sx={{
                                color: "#fff",
                                "& .MuiAutocomplete-option": {
                                    "&:hover": {
                                        bgcolor: "#241815",
                                    },
                                    "&[aria-selected='true']": {
                                        bgcolor: "#241815",
                                    },
                                },
                            }}>
                                {children}
                            </Box>
                        )}
                    />
                    {/* <Box className="ms-auto d-flex justify-content-between gap-2">
                        <Button variant="contained" className='bg-orange' onClick={() => { handleDownloadUsersExcel() }}>
                            Export As Excel
                        </Button>
                    </Box> */}
                </Box>
                <>
                    <TableContainer
                        sx={{
                            maxHeight: "60vh",
                            overflow: "auto"
                        }}
                    >
                        <Table
                            stickyHeader
                            sx={{
                                "& .MuiTableCell-root": {
                                    borderBottom: "none",
                                },
                                "& .MuiTableRow-root": {
                                    borderBottom: "none",
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    {HEAD_COLS.map((col) => (
                                        <TableCell
                                            className='color-primary'
                                            key={col.label}
                                            sortDirection={col.sortKey && sortKey === col.sortKey ? sortDir : false}
                                            sx={{
                                                backgroundColor: "#241815",
                                                color: "#ff6a3d",
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                            }}
                                        >
                                            {col.sortKey ? (
                                                <TableSortLabel
                                                    active={sortKey === col.sortKey}
                                                    direction={sortKey === col.sortKey ? sortDir : 'desc'}
                                                    onClick={() => handleSort(col.sortKey!)}
                                                    sx={{
                                                        color: '#ff6a3d !important',
                                                        '& .MuiTableSortLabel-icon': {
                                                            color: '#ff6a3d !important',
                                                            opacity: sortKey === col.sortKey ? 1 : 0.3,
                                                        },
                                                    }}
                                                >
                                                    {col.label}
                                                </TableSortLabel>
                                            ) : (
                                                col.label
                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {users.map((user, index) => (
                                    <TableRow key={user._id}>
                                        <TableCell className='text-white py-1'>{page * rowsPerPage + index + 1}</TableCell>
                                        <TableCell className='text-white py-1'>
                                            {user.firstName} {user.lastName}
                                        </TableCell>
                                        <TableCell className='text-white py-1'>{user?.email}</TableCell>
                                        <TableCell className='text-white py-1'>{user?.phoneNumber || "-"}</TableCell>
                                        <TableCell className='text-white py-1'>{user?.country || "-"}</TableCell>
                                        <TableCell className='text-white py-1'>{user?.state || "-"}</TableCell>
                                        <TableCell className='text-white py-1'>
                                            <Tooltip title="Credit Spins" arrow>
                                                <IconButton sx={{ color: '#10b981' }} onClick={() => {
                                                    setPendingSpinUser(user)
                                                    setPendingSpinDirection("CREDIT")
                                                    setSpinCount('')
                                                    setSpinReason('')
                                                    setSpinCountError('')
                                                    setSpinReasonError('')
                                                    setSpinReasonOpen(true)
                                                }}>
                                                    <AddCircleOutlineIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Debit Spins" arrow>
                                                <IconButton sx={{ color: '#ef4444' }} onClick={() => {
                                                    setPendingSpinUser(user)
                                                    setPendingSpinDirection("DEBIT")
                                                    setSpinCount('')
                                                    setSpinReason('')
                                                    setSpinCountError('')
                                                    setSpinReasonError('')
                                                    setSpinReasonOpen(true)
                                                }}>
                                                    <RemoveCircleOutlineIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell className='text-white py-1'>
                                            <Typography fontSize={13} color="#e0e0e0">{fmtDate(user.createdAt)}</Typography>
                                            <Typography fontSize={10} color="#5a5a5a">{fmtTime(user.createdAt)}</Typography>
                                        </TableCell>
                                        <TableCell className='text-white py-1'>
                                            <Typography fontSize={13} color="#e0e0e0">{fmtDate(user.lastLoggedin)}</Typography>
                                            <Typography fontSize={10} color="#5a5a5a">{fmtTime(user.lastLoggedin)}</Typography>
                                        </TableCell>
                                        <TableCell className='py-1 d-flex align-items-center gap-2'>
                                            <Tooltip title="View User Details" arrow>
                                                <IconButton className='color-primary' onClick={() => navigate('/admin/users/userDetails', { state: { id: user._id, aeropay_userId: user.aeropay_userId } })}>
                                                    <PersonIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="View User's Activity" arrow>
                                                <IconButton onClick={() => navigate("/admin/user-activity", { state: { userId: user._id, userName: `${user.firstName} ${user.lastName}` } })}>
                                                    <img src={UserActivityLogo} height={"30px"} alt="User Activity" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="View User's Referrals" arrow>
                                                <IconButton onClick={() => navigate("/admin/referral-summary", { state: { userId: user._id, userName: `${user.firstName} ${user.lastName}` } })}>
                                                    <Referrals />
                                                </IconButton>
                                            </Tooltip>

                                        </TableCell>
                                        <TableCell className='py-1'>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        className='bg-dark-color'
                        component="div"
                        count={totalRows}
                        page={page}
                        onPageChange={(_, newPage) => setPage(newPage)}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(e) => {
                            setRowsPerPage(parseInt(e.target.value, 10));
                            setPage(0);
                        }}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        showFirstButton
                        showLastButton
                        sx={{
                            color: "#898989",
                            borderTop: "1px solid #2a2a2a",

                            "& .MuiTablePagination-toolbar": {
                                justifyContent: "center",
                            },

                            "& .MuiTablePagination-selectLabel": {
                                color: "#898989",
                                margin: 0,
                            },
                            "& .MuiTablePagination-displayedRows": {
                                color: "#898989",
                                margin: 0,
                            },

                            "& .MuiSelect-select": {
                                color: "#898989",
                            },
                            "& .MuiSelect-icon": {
                                color: "#898989",
                            },

                            "& .MuiIconButton-root": {
                                color: "#898989",
                            },
                            "& .MuiIconButton-root.Mui-disabled": {
                                color: "#555",
                            },
                        }}
                    />
                </>
            </Box>
            <Dialog
                open={spinReasonOpen}
                onClose={() => setSpinReasonOpen(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: '#242424',
                        borderRadius: '16px',
                        boxShadow: pendingSpinDirection === 'CREDIT' ? '0 0 60px rgba(16,185,129,.25)' : '0 0 60px rgba(239,68,68,.25)',
                        border: '1px solid #333',
                        overflow: 'hidden',
                    }
                }}
            >
                <DialogTitle sx={{
                    background: pendingSpinDirection === 'CREDIT'
                        ? 'linear-gradient(135deg, #10b981, #059669)'
                        : 'linear-gradient(135deg, #ef4444, #dc2626)',
                    color: '#fff', display: 'flex', alignItems: 'center',
                    justifyContent: 'space-between', fontWeight: 700, mb: 0, fontSize: 15,
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box sx={{ width: 32, height: 32, borderRadius: '8px', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {pendingSpinDirection === 'CREDIT' ? <AddCircleOutlineIcon fontSize="small" /> : <RemoveCircleOutlineIcon fontSize="small" />}
                        </Box>
                        {pendingSpinDirection === 'CREDIT' ? 'Credit Spins' : 'Debit Spins'}
                    </Box>
                    <IconButton onClick={() => setSpinReasonOpen(false)} size="small">
                        <CloseIcon sx={{ color: '#fff', fontSize: 18 }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ backgroundColor: '#242424', pt: '20px !important' }}>
                    <Typography fontSize={11} color="#5a5a5a" mb={1} letterSpacing="0.08em" textTransform="uppercase">
                        User
                    </Typography>
                    <Typography fontSize={13} color="#e0e0e0" mb={2}>
                        {pendingSpinUser?.firstName} {pendingSpinUser?.lastName} ({pendingSpinUser?.email})
                    </Typography>

                    <Typography fontSize={11} color="#5a5a5a" mb={1} letterSpacing="0.08em" textTransform="uppercase">
                        Spin Count
                    </Typography>
                    <TextField
                        fullWidth
                        type="number"
                        placeholder="0"
                        value={spinCount}
                        onChange={(e) => { setSpinCount(e.target.value); setSpinCountError('') }}
                        error={!!spinCountError}
                        helperText={spinCountError}
                        sx={{
                            mb: 2.5,
                            '& input': { color: '#fff', fontSize: 16, fontWeight: 700 },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                '& fieldset': { borderColor: '#333' },
                                '&:hover fieldset': { borderColor: '#f2674a50' },
                                '&.Mui-focused fieldset': { borderColor: '#f2674a' },
                            },
                            '& .MuiFormHelperText-root': { color: '#ef4444', fontSize: 11 },
                        }}
                    />

                    <Typography fontSize={11} color="#5a5a5a" mb={1} letterSpacing="0.08em" textTransform="uppercase">
                        Reason
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        minRows={2}
                        maxRows={5}
                        placeholder="Enter reason for this adjustment…"
                        value={spinReason}
                        onChange={(e) => { setSpinReason(e.target.value); setSpinReasonError('') }}
                        error={!!spinReasonError}
                        helperText={spinReasonError}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px', color: '#fff',
                                '& fieldset': { borderColor: '#333' },
                                '&:hover fieldset': { borderColor: '#f2674a50' },
                                '&.Mui-focused fieldset': { borderColor: '#f2674a' },
                            },
                            '& textarea': { color: '#fff', fontSize: 13 },
                            '& textarea::placeholder': { color: '#555', opacity: 1 },
                            '& .MuiFormHelperText-root': { color: '#ef4444', fontSize: 11 },
                        }}
                    />
                </DialogContent>

                <Box sx={{ px: 3, pb: 3, pt: 1, display: 'flex', gap: 1.5 }}>
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => setSpinReasonOpen(false)}
                        sx={{ borderColor: '#333', color: '#7a7a7a', borderRadius: '10px', '&:hover': { borderColor: '#555', color: '#fff' } }}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            const count = parseInt(spinCount, 10)
                            if (!Number.isInteger(count) || count <= 0) {
                                setSpinCountError('Enter a valid spin count')
                                return
                            }
                            if (!spinReason.trim()) {
                                setSpinReasonError('Please provide a reason')
                                return
                            }
                            setSpinReasonOpen(false)
                            setConfirmSpinOpen(true)
                        }}
                        sx={{
                            background: pendingSpinDirection === 'CREDIT'
                                ? 'linear-gradient(135deg, #10b981, #059669)'
                                : 'linear-gradient(135deg, #ef4444, #dc2626)',
                            borderRadius: '10px', fontWeight: 700,
                        }}
                    >
                        Continue
                    </Button>
                </Box>
            </Dialog>

            <PopupDialog
                open={confirmSpinOpen}
                onClose={() => setConfirmSpinOpen(false)}
                onConfirm={handleAdjustSpins}
                loading={spinSubmitting}
                variant={pendingSpinDirection === 'CREDIT' ? 'deposit' : 'error'}
                title={pendingSpinDirection === 'CREDIT' ? 'Confirm Spin Credit' : 'Confirm Spin Debit'}
                message={`You are about to ${pendingSpinDirection === 'CREDIT' ? 'credit' : 'debit'} spins for this user.`}
                confirmText={pendingSpinDirection === 'CREDIT' ? 'Confirm Credit' : 'Confirm Debit'}
                details={[
                    {
                        label: 'User',
                        value: pendingSpinUser ? `${pendingSpinUser.firstName} ${pendingSpinUser.lastName}` : '—',
                        sub: pendingSpinUser?.email ?? '—',
                    },
                    { label: 'Spin Count', value: spinCount || '0' },
                    { label: 'Reason', value: spinReason },
                    {
                        label: 'Timestamp',
                        value: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
                        mono: true,
                    },
                ]}
                notice={
                    pendingSpinDirection === 'DEBIT'
                        ? "This will fail if the user's available spin balance is insufficient. This action is logged."
                        : "This action is logged and cannot be undone."
                }
            />

            <PopupDialog
                open={successPopup.open}
                onClose={() => setSuccessPopup({ open: false, message: '' })}
                onConfirm={() => setSuccessPopup({ open: false, message: '' })}
                variant="success"
                title="Success"
                message={successPopup.message}
                confirmText="Done"
                cancelText="Close"
            />
            <PopupDialog
                open={errorPopup.open}
                onClose={() => setErrorPopup({ open: false, message: '' })}
                onConfirm={() => setErrorPopup({ open: false, message: '' })}
                variant="error"
                title="Something Went Wrong"
                message={errorPopup.message}
                confirmText="Try Again"
                cancelText="Dismiss"
            />
        </div>
    )
}

export default Users